import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, description, testid }) => (
  <div className="max-w-3xl" data-testid={testid}>
    <Reveal>
      <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#3B82F6] sm:text-sm">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display mt-3 text-2xl font-extrabold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-sm leading-relaxed text-gray-400 sm:text-base">{description}</p>
      </Reveal>
    )}
  </div>
);
